import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ResourceEditSmartComponent } from './edit/resource-edit-smart.component';
import { ResourceEditGuard } from './edit/resource-edit.guard';
import { ResourceSmartComponent } from './resource-smart.component';
import { ResourceGuard } from './resource.guard';

const resourceRoutes: Routes = [
  {
    path: '',
    component: ResourceSmartComponent,
    canActivate: [ResourceGuard],
    resolve: {
      bibliographicResource: ResourceGuard,
    },
  },
  {
    path: 'edit.html',
    component: ResourceEditSmartComponent,
    canActivate: [ResourceGuard, ResourceEditGuard],
    resolve: {
      bibliographicResource: ResourceGuard,
    },
  },
];

export const ResourceRoutingModule: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(resourceRoutes);
